<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">渠道短信签名</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="status" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in statusArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editSignDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column prop="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"></el-table-column>
          <el-table-column prop="packageName" label="包名" v-if="checkColList.indexOf('包名') > -1"></el-table-column>
          <el-table-column prop="templateId" label="短信模板ID" v-if="checkColList.indexOf('短信模板ID') > -1"></el-table-column>
          <el-table-column prop="remark" label="签名备注" v-if="checkColList.indexOf('签名备注') > -1"></el-table-column>
          <el-table-column prop="" label="类型" v-if="checkColList.indexOf('类型') > -1">
            <template #default="scope">
              <span>{{scope.row.type==1?'验证码':''}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <span>{{scope.row.status==0?'待开启':scope.row.status==1?'已开启':scope.row.status==2?'已关闭':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editSignDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.status == 0 || scope.row.status == 2" @click="updateState(scope.$index, scope.row, 1)">开启</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-if="scope.row.status == 0 || scope.row.status == 1" @click="updateState(scope.$index, scope.row, 2)">关闭</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getSubmailConfigPageList, updateStateSubmailConfig } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import signDialog from "./components/signDialog";

export default {
  name: "SmsSign",
  data() {
    return {

      //状态
      statusArray: [
        {label: '不限', value: -1},
        {label: '待开启', value: 0},
        {label: '已开启', value: 1},
        {label: '已关闭', value: 2},
      ],
      status: 1,

      //搜索
      searchTypeList: [
        {label : '城市名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['创建时间', '包名', '短信模板ID', '签名备注', '类型', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.status = 1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['status'] = this.status;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSubmailConfigPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editSignDialog(idx, row) {
      let _title = '';
      let signForm = {}
      if (idx > -1) {
        _title = '编辑'
        signForm = Object.assign({}, row);
      }else {
        _title = '新建'
      }
      Dialog.open({
        title: _title,
        component: signDialog,
        data: {
          signForm: signForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['status'] = state;
      postFormData(updateStateSubmailConfig, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.status = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
